import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import SparkRunsHistory from '../sparkRunHistory/SparkRunsHistory';
import { useInfiniteSparksQuery } from 'hooks/spark';
import { Link } from 'react-router-dom';
import { SPARK_ROUTES } from 'constants/routes';
import DashboardTopSection from './DashboardTopSection';
import SparkCarousel from 'sharedComponents/UI/SparkCarousel';
import SparkCard from 'components/common/SparkCard';
import { SPARK_RESOURCE_TYPES } from 'constants/common';

function Dashboard() {
  const {
    joinedSparks,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isLoading: isSparkDataLoading,
    isFetchingNextPage,
  } = useInfiniteSparksQuery({
    url: SPARK_RESOURCE_TYPES.SPARKS + '?sort=-modifiedAt',
  });
  const handlePageUpdate = () => {
    if (!hasNextPage && isFetching) {
      return;
    }
    fetchNextPage();
  };

  return (
    <Grid container justifyContent='center' component='div'>
      <DashboardTopSection />
      <Grid item xs={12} justifySelf='flex-start'>
        <Typography
          variant='h5'
          sx={{
            fontFamily: 'Mont-semiBold',
            paddingTop: 2,
            color: '#404040',
            margin: '1rem 0 1rem 0',
            paddingLeft: 2,
          }}
        >
          You might want to try...
        </Typography>
      </Grid>
      {!isSparkDataLoading && !joinedSparks?.length ? (
        <Grid
          container
          justifyContent='center'
          alignItems='center'
          gap={2}
          minHeight={100}
        >
          <Typography>No spark Found</Typography>
          <Link
            to={SPARK_ROUTES.SPARK_BUILDER}
            style={{
              textDecoration: 'none',
              color: '#6267AC',
            }}
          >
            <Typography
              sx={{
                textDecoration: 'none',
                fontSize: '14px',
              }}
            >
              Create a Spark
            </Typography>
          </Link>
        </Grid>
      ) : (
        <>
          <SparkCarousel
            onLastElementView={handlePageUpdate}
            isLoading={isSparkDataLoading}
            isFetchingNextPage={isFetchingNextPage}
          >
            {joinedSparks?.map((JoinedSpark) => (
              <SparkCard key={JoinedSpark.id} joinedSpark={JoinedSpark} />
            ))}
          </SparkCarousel>

          <Grid item alignItems='center' xs={12}>
            <Typography
              variant='h5'
              sx={{
                fontFamily: 'Mont-semiBold',
                lineGeight: 'normal',
                my: 3,
                color: '#404040',
                paddingLeft: 2,
              }}
            >
              Recent Spark Runs
            </Typography>
            <Box
              sx={{
                mb: 8,
                maxHeight: 500,
                mt: 0,
                backgroundColor: '#F9F9F9',
                boxShadow: 'none',
                pl: 2,
              }}
            >
              <SparkRunsHistory
                paginatedQuery={{ pageNumber: 1, pageSize: 5 }}
                showAvatarAndName={true}
              />
            </Box>
          </Grid>
        </>
      )}
    </Grid>
  );
}

export default Dashboard;
